import { saveEmoji } from '@/helpers/saveEmoji'
import { saveEmote } from '@/helpers/saveEmote'
import { useEvent } from '@utsubo/events'
import { useRef } from 'react'

async function saveAllLogsToFirestore(
  logsInCurrentSession,
  workspace,
  microverse
) {
  let groupedLogs = [...logsInCurrentSession.current]
  logsInCurrentSession.current = []
  console.log('will save', groupedLogs)
  try {
    await fetch('/api/user-session-logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ logs: groupedLogs, workspace, microverse }),
    })
  } catch (err) {}
}

export const useSessionLogs = (workspace, microverse) => {
  const logsInCurrentSession = useRef([])
  useEvent('register-session-log', (log) => {
    if (process.env.NODE_ENV === 'development') return

    const improvedLog = {
      timestamp: new Date().getTime(),
      host: typeof window !== 'undefined' ? window.location.host : '',
      microverse: microverse,
      workspace: workspace,
      ...log,
    }
    logsInCurrentSession.current.push(improvedLog)
  })

  useEvent('register-action-log', (log) => {
    if (process.env.NODE_ENV === 'development') return

    if (log.type === 'emote') {
      saveEmote(workspace, microverse, log.emoteName)
    } else if (log.type === 'emoji') {
      saveEmoji(workspace, microverse, log.emojiId)
    }
  })

  useEvent('postAnimFinishLoad', () => {
    if (process.env.NODE_ENV === 'development') return

    setTimeout(() => {
      saveAllLogsToFirestore(logsInCurrentSession, workspace, microverse)
    }, 3000)
  })
}
